import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { createCoroutineUninterceptedGeneratorVersion2gduom218i9ay as createCoroutineUninterceptedGeneratorVersion } from '../coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../hacks.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
} from '../Result.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../coroutines/intrinsics/Intrinsics.mjs';
import { EmptyCoroutineContext_instance101eax45qp7ot as EmptyCoroutineContext_instance } from '../coroutines/CoroutineContextImpl.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../coroutines/Continuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function sequence(block) {
  // Inline function 'kotlin.sequences.Sequence' call
  return new (sequence$$inlined$Sequence$1())(block);
}
var SequenceScopeClass;
function SequenceScope() {
  if (SequenceScopeClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SequenceScope', VOID, VOID, VOID, [1]);
    SequenceScopeClass = $;
  }
  return SequenceScopeClass;
}
function iterator(block) {
  var iterator = new (SequenceBuilderIterator())();
  iterator.rk_1 = createCoroutineUninterceptedGeneratorVersion(block, iterator, iterator);
  return iterator;
}
function nextNotReady($this) {
  if (!$this.q1())
    throw NoSuchElementException().t6();
  else
    return $this.r1();
}
function exceptionalState($this) {
  switch ($this.ok_1) {
    case 4:
      return NoSuchElementException().t6();
    case 5:
      return IllegalStateException().o('Iterator has failed.');
    default:
      return IllegalStateException().o('Unexpected state of the iterator: ' + $this.ok_1);
  }
}
var SequenceBuilderIteratorClass;
function SequenceBuilderIterator() {
  if (SequenceBuilderIteratorClass === VOID) {
    class $ extends SequenceScope() {
      constructor() {
        super();
        this.ok_1 = 0;
        this.pk_1 = null;
        this.qk_1 = null;
        this.rk_1 = null;
      }
      q1() {
        while (true) {
          switch (this.ok_1) {
            case 0:
              break;
            case 1:
              if (ensureNotNull(this.qk_1).q1()) {
                this.ok_1 = 2;
                return true;
              } else {
                this.qk_1 = null;
              }

              break;
            case 4:
              return false;
            case 3:
            case 2:
              return true;
            default:
              throw exceptionalState(this);
          }
          this.ok_1 = 5;
          var step = ensureNotNull(this.rk_1);
          this.rk_1 = null;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
          step.oc(tmp$ret$1);
        }
      }
      r1() {
        switch (this.ok_1) {
          case 0:
          case 1:
            return nextNotReady(this);
          case 2:
            this.ok_1 = 1;
            return ensureNotNull(this.qk_1).r1();
          case 3:
            this.ok_1 = 0;
            var result = this.pk_1;
            this.pk_1 = null;
            return result;
          default:
            throw exceptionalState(this);
        }
      }
      *nk(value, $completion) {
        this.pk_1 = value;
        this.ok_1 = 3;
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        (yield () => {
          this.rk_1 = $completion;
          return get_COROUTINE_SUSPENDED();
        });
        return Unit_instance;
      }
      sk(result) {
        // Inline function 'kotlin.getOrThrow' call
        throwOnFailure(result);
        _Result___get_value__impl__bjfvqg(result);
        this.ok_1 = 4;
      }
      oc(result) {
        return this.sk(result);
      }
      mc() {
        return EmptyCoroutineContext_instance;
      }
    }
    initMetadataForClass($, 'SequenceBuilderIterator', SequenceBuilderIterator, VOID, [Continuation()], [1]);
    SequenceBuilderIteratorClass = $;
  }
  return SequenceBuilderIteratorClass;
}
var sequence$$inlined$Sequence$1Class;
function sequence$$inlined$Sequence$1() {
  if (sequence$$inlined$Sequence$1Class === VOID) {
    class $ {
      constructor($block) {
        this.tk_1 = $block;
      }
      p1() {
        return iterator(this.tk_1);
      }
    }
    initMetadataForClass($);
    sequence$$inlined$Sequence$1Class = $;
  }
  return sequence$$inlined$Sequence$1Class;
}
//region block: exports
export {
  SequenceScope as SequenceScope1coiso86pqzq2,
  iterator as iterator3f5i676wpaa3g,
  sequence as sequence2vgswtrxvqoa7,
};
//endregion

//# sourceMappingURL=SequenceBuilder.mjs.map
